module.exports = __webpack_public_path__ + "img/icon_drill_plus.abdf5b16.png";